export const MuiDrawer = {
  MuiDrawer: {
    paper: {
      //
    },
  },
};
